<template>
  <div>
    <b-table
      :key="keyTableRender"
      id="table"
      :items="rows"
      :fields="schema"
      class="m-2"
    >
      <template #cell(actions)="row">
        <b-button  v-if="row.item.id !== 1" variant="none" size="sm" class="px-04" @click="openModal('ModalTableAssociateList', row.item, 'current' )">
          <feather-icon icon="ListIcon" v-b-tooltip.hover class="text-primary" title="Lista actual" />
        </b-button>
        <b-button  v-if="row.item.id !== 1" variant="none" size="sm" class="px-04" @click="openModal('ModalTableAssociateList', row.item, 'future' )">
          <img :src="'/icon/future-clock.svg'" v-b-tooltip.hover title="Lista programada" />
        </b-button>
        <b-button v-if="row.item.id !== 1" variant="none" size="sm" class="px-04" @click="openModal('ModalAssociateList', row.item)">
          <feather-icon icon="PlusCircleIcon" class="text-primary" v-b-tooltip.hover title="Asociar Lista" />
        </b-button>
        <!-- <b-button  v-if="row.item.id !== 1" variant="none" size="sm" class="px-04" @click="openModal('ModalTableAssociateList', row.item)">
          <feather-icon icon="TrashIcon" class="text-danger" v-b-tooltip.hover title="Eliminar Asociación de Lista" />
        </b-button> -->
      </template>
    </b-table>
    <modal-associate-list v-if="isOpenModalAssociateList" :formTableList="formTableList" ref="ModalAssociateList" @closeModal="closeModal"></modal-associate-list>
    <modal-table-associate-list v-if="isOpenModalTableAssociateList" :formTableList="formTableList" ref="ModalTableAssociateList" @closeModal="closeModal" ></modal-table-associate-list>
  </div>
</template>
<script>
import ModalAssociateList from './ModalAssociateList.vue'
import ModalTableAssociateList from './ModalTableAssociateList.vue'

export default {
  name: 'TablePricesList',
  components: { ModalAssociateList, ModalTableAssociateList },
  props: ['rows', 'getList', 'formCountryCourier'],
  data() {
    return {
      keyTableRender: 0,
      schema: [],
      isOpenModalAssociateList: false,
      isOpenModalTableAssociateList: false,
      formTableList: {}
    }
  },
  mounted() {
    this.setInitialData()
  },
  watch: {
  },
  methods: {
    setInitialData() {
      this.setSchema()
    },
    setSchema() {
      this.schema = [
        {label: 'Nombre', key: 'name', class: 'text-left'},
        {label: 'Descripción', key: 'description', class: 'text-left'},
        {label: 'Acciones', key: 'actions', class: 'text-center', useSlot: true}
      ]
    },
    openModal(name, row, actionType) {
      this.formTableList = {
        row,
        carrier: this.formCountryCourier.carrier,
        country: this.formCountryCourier.country,
        servicesOptions: this.formCountryCourier.servicesOptions,
        actionType
      }
      this[`isOpen${name}`] = true
      this.$nextTick(() => {
        this.$refs[name].setInitialData()
        this.$bvModal.show(name)
      })
    },
    closeModal(name) {
      this.$bvModal.show(name)
      this[`isOpen${name}`] = false
    }
  }
}
</script>
<style>
</style>
